<template>
<div class="beforeMain">
    <Boxingheader :pageTitle="'往期中奖记录'"></Boxingheader>
  <div class="my_prize_wrap">
    <div :class="!prizeList.length ? 'my_prize_recode my_min_height' : 'my_prize_recode'">
      <div class="my_prize_title">
        中奖记录
      </div>
      <div class="my_no_content" v-if="!prizeList.length">
        <img src="https://images01.zhibo.tv/olympics/no_content_icon.png" />
        <div>暂时没有奖品</div>
      </div>
      <div v-else-if="prizeList.length">
        <div :key="index" class="my_prize_item" v-for="(item,index) in prizeList">
          <div class="my_prize_item_name">
            <div>
              {{item.is_prize == 0 ? '中国体育' + item.title : item.title}}
              <img @click="openEquity" class="look_equity" src="https://images01.zhibo.tv/olympics/watch_more.png" v-if="item.is_prize == 0" />
            </div>
            <!-- <div class="look_equity" @click="openEquity">查看权益</div> -->
          </div>
          <!-- <image a:if="{{item.is_prize == 0}}" mode="scaleToFill" src="https://images01.zhibo.tv/olympics/prize_equity_icon.png" @click="openEquity" class="equity_icon"/> -->
          <div class="my_prize_item_num">x1</div>
          <div class="my_prize_item_time">{{item.created}}</div>
        </div>
      </div>
    </div>
    <div class="my_prize_dic" v-if="prizeList.length">
      <div>实物奖品在活动结束后10个工作日内寄出。</div>
      <!-- <div>会员卡奖品在当期活动结束后10个工作日发放至当前账户。</div> -->
    </div>
    <div class="my_equity_mark" v-if="isShowEquityMark">
      <div class="equity_container">
        <img class="my_equity_img" src="https://images01.zhibo.tv/olympics/prize_equity_img.png" />
        <img @click="openEquity" class="my_equity_close" src="https://images01.zhibo.tv/olympics/icon_close0806.png" />
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
import Boxingheader from "@/components/BoxingHeader";
export default {
  components: {
    Boxingheader
  },
  data() {
    return {
      prizeList: [],
      userInfo: {},
      user_id: '8957593',
      isAdrInfo: false,
      isShowEquityMark: false,
    }
  },
  created(){
    this.setTitle('往期中奖记录')
    if(this.$route.query.share=='1'){
      this.token = this.$cookies.get("token");
    }else{
      this.token =
      this.$getcommit("token") ||
      JSON.parse(sessionStorage.getItem("userToken")) ||
      this.$route.query.token;
    }
    this.teamId = JSON.parse(sessionStorage.getItem("drawteamId"))
    
    this.token = this.token ? decodeURIComponent(this.token) : ''
    // this.token = 'c4282424f4b01a7e7c8eafb714ded591*6341172'

    this.userId = this.token ? this.token.split('*')[1]:''

    if(this.userId){
      this.getInfo()
      this.getUserInfo()
    }
  },
  mounted(){

  },
  methods: {
    // 原生设置title
    setTitle(title){
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(title)
      } catch (e) {
        window.console.log(0)
      }
      try {
        window.LiveAppJS.changeTitle(title)
      } catch (e) {
        window.console.log(1)
      }
    },
    openEquity() {
      this.isShowEquityMark = !this.isShowEquityMark
    },
    // 获取奖品信息
    async getInfo() {
      let params = {
        userid: this.userId,
        id: this.teamId
      }
      let res = await this.$api.getDrawHistory(params)
      let arr = res.data.data
      this.prizeList = arr
      this.isAdrInfo = arr.some((item) => item.is_prize == 1)

      // this.isAdrInfo = true
    },
    async getUserInfo() {
      let params = {
        userid:this.userId
      }
      let res = await this.$api.getDrawUserAddress(params)
      this.userInfo = Array.isArray(res.data.data) ? {} : res.data.data
    },
    // 收货地址修改
    toEditAddress() {
      if(this.$route.query.share=='1'){
        this.$router.push({
          name: 'address',
          query:{
            userId: this.userId,
            token: this.token,
            share: '1'
          }
        })
      }else{
        this.$router.push({
          name: 'address',
          query:{
            userId: this.userId,
            token: this.token
          }
        })
      }
      // my.navigateTo({
      //   url: '/pages/myAddress/index?userId=' + this.data.user_id,
      // })
    },
    // 跳转中奖细则
    gotoRule() {
      if(this.$route.query.share=='1'){
        this.$router.push({
          name:'drawrule',
          query:{
            userId: this.userId,
            token: this.token,
            share: '1'
          }
        })
      }else{
        this.$router.push({
          name:'drawrule',
          query:{
            userId: this.userId,
            token: this.token
          }
        })
      }
    },
    // 往期中奖记录
    beforePrize(){
      if(this.$route.query.share=='1'){
        this.$router.push({
          name:'drawrule',
          query:{
            userId: this.userId,
            token: this.token,
            share: '1'
          }
        })
      }else{
        this.$router.push({
          name:'drawrule',
          query:{
            userId: this.userId,
            token: this.token
          }
        })
      }
    }
  },
}
</script>

<style lang="less" scoped>
page {
  height: 100%;
  background: #f7f7fa !important;
}
.beforeMain{
  min-height: 100vh;
  background: #f7f7fa;
  padding-top: .9rem;
  box-sizing: border-box;
}

.my_prize_wrap {
  width: 100%;
  padding: 0.3rem;
  box-sizing: border-box;
  // margin-bottom: .3rem;
}

.my_prize_recode {
  width: 6.9rem;
  height: auto;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.4rem 0.4rem 0.1rem 0.4rem;
  box-sizing: border-box;
}

.my_min_height {
  min-height: 6.6rem;
}

.my_prize_title {
  position: relative;
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.42rem;
  margin-bottom: 0.08rem;
  text-align: center;
}

.my_prize_title .rule {
  position: absolute;
  right: 0;
  top: 0.06rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fc1930;
  line-height: 0.3rem;
}

.my_no_content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 1.3rem;
  align-items: center;
  height: 3rem;
}

.my_no_content img {
  width: 2.2rem;
  height: 2.2rem;
  display: block;
}

.my_no_content div {
  font-size: 0.28rem;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #666666;
  line-height: 0.4rem;
  margin-top: 0.4rem;
}

.my_prize_item {
  height: 1.12rem;
  background: #ffffff;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.my_prize_item_num {
  font-size: 0.29rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  width: 1.61rem;
  text-align: right;
}

.my_prize_item_name {
  display: inline-flex;
  align-items: center;
  width: 2rem;
}
.my_prize_item_name > div {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 0.4rem;
}
.my_prize_item_time {
  flex: 1;
  text-align: right;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.my_prize_dic {
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.36rem;
  margin: 0.43rem 0 0.4rem 0;
  padding: 0 0.1rem;
  letter-spacing: 0.01rem;
  text-align: justify;
  .prize_rule{
    font-size: .24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: .33rem;
    margin-top: .1rem;
  }
}


.my_prize_dic div {
  display: block;
  padding-bottom: 0.2rem;
}

.my_edit_address_btn {
  width: 100%;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  background: url(https://images01.zhibo.tv/olympics/save_btn_bj.png) no-repeat;
  background-size: 100% 100%;
}

.my_user_info {
  margin-top: 0.3rem;
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.35rem 0.4rem 0.66rem 0.4rem;
  box-sizing: border-box;
}

.my_user_info_item {
  height: 1.12rem;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.my_user_info_item > div {
  font-size: 0.3rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.my_user_info_item > div:first-child {
  min-width: 1.71rem;
  max-width: 1.71rem;
}

.my_user_info_item > div:last-child {
  color: #666666;
  flex: 1;
  overflow: hidden;
  word-break: break-all;
}

.equity_icon {
  width: 1.08rem;
  height: 0.39rem;
  position: absolute;
  left: 2.35rem;
}

.my_equity_mark {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
}

.equity_container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.equity_container .my_equity_img {
  width: 6.2rem;
  height: 7.53rem;
  margin-top: -1.2rem;
}

.equity_container .my_equity_close {
  width: 0.56rem;
  height: 0.56rem;
  margin-top: 0.48rem;
}
.look_equity {
  width: 0.68rem;
  height: 0.32rem;
  margin-left: 0.1rem;
  position: relative;
  top: 0.066rem;
}
</style>